import { SpecificationPointer } from '../input/variant-specification/types';
import { ProgressStatus } from '../update/progress/types';

export enum SnapshotType {
  LEGACY = 'l',
  MASTER = 'm',
  BASIC = 'b',
  PUBLISHABLE = 'p',
  FULL = 'f',
  DOWNGRADED = 'g',
  DELETED = 'd',
}

export interface MasterVersion {
  number: 'master';
  type: SnapshotType.MASTER;
  description: string;
  finishedOn: string | null;
  startedOn: string | null;
  status: ProgressStatus;
}

export type ModelVersion =
  | MasterVersion
  | {
      number: string;
      type: SnapshotType;
      description: string;
      finishedOn: string | null;
      startedOn: string;
      status: ProgressStatus;
    };

export type ProductTarget = string | SpecificationPointer.NIGHTLY;
